




















import { Vue, Component, Watch } from 'vue-property-decorator'
import { Container, Logo, Box, PositiveSubheader, CustomLink } from '../atoms/'
import { REDIRECT_COUNT_DOWN_TIME } from '../../constant/config'
import { mapActions, mapGetters } from 'vuex'
import { USER_MODULE, CONFIRM_EMAIL } from '../../store/modules/user/constant'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Container,
    Logo,
    Box,
    PositiveSubheader,
    CustomLink
  },
  methods: {
    ...mapActions(USER_MODULE, [CONFIRM_EMAIL])
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class EmailConfirmSuccess extends Vue {
  private redirectCountdown: number = REDIRECT_COUNT_DOWN_TIME

  @Watch('redirectCountdown', {
    immediate: true
  })
  decreaseRedirectCountdown(countdownTime: number) {
    if (countdownTime > 0) {
      setTimeout(() => {
        this.redirectCountdown--
      }, 1000)
    } else {
      const redirectLink = this.redirectLink ? this.redirectLink : process.env.VUE_APP_FINNO_ENDPOINT
      location.replace(redirectLink)
    }
  }

  mounted() {
    this.doConfirmEmail()
  }

  get email(): string {
    return this.$route?.query?.email as string
  }
  get cipher(): string {
    return this.$route?.query?.q as string
  }
  get redirectLink(): string {
    return this.$route?.query?.redirect_to as string
  }
  doConfirmEmail() {
    const payload = {
      email: this.email,
      cipher: this.cipher
    }
    return (this as any)[CONFIRM_EMAIL](payload)
  }
}
